import {ProductInterface} from "../../interfaces/catalog/ProductInterface";
import Money from "../core/Money";
import {Link} from "react-router-dom";
import useComparison from "../../utils/useComparison";
import useFavorite from "../../utils/useFavorite";
import useBasket from "../../utils/useBasket";

export default function Product({product}: { product: ProductInterface }) {

    const {inComparison, toggleComparison} = useComparison(product);
    const {inFavorites, toggleFavorite} = useFavorite(product);
    const {addToBasket, inBasket} = useBasket(product);

    return (<div className="d-flex flex-column prod-card__content">
            <div className="prod-card__top">
                <div className="d-flex align-items-center justify-content-between g-3 prod-card__head">
                    <p className="t-gray fw-medium m-0 prod-card__h-text">код: {product.code}</p>
                    <div className="d-flex align-items-center prod-card__i-row">
                        <div className={'prod-card__h-i prod-card__h-i-like ' + (inFavorites() && '_active')}
                             onClick={() => {
                                 if (!product.id.toString()) return
                                 toggleFavorite()
                             }}></div>
                        <div className={'prod-card__h-i prod-card__h-i-stat ' + (inComparison() && '_active')}
                             onClick={() => {
                                 if (!product.id.toString()) return
                                 toggleComparison()
                             }}></div>
                    </div>
                </div>
                <div className="prod-card__img-box">
                    {/*<Swiper*/}
                    {/*    modules={[Zoom]}*/}
                    {/*    initialSlide={initialSlideIndex}*/}
                    {/*    zoom={true}*/}
                    {/*    onSlideChange={(swiper: any) => setSlideIndex(swiper.activeIndex)}*/}
                    {/*    onSwiper={(swiper: any) => {*/}
                    {/*        swiperRef.current = swiper;*/}
                    {/*    }}*/}
                    {/*>*/}
                    {/*    {images.map((image, index) => (*/}
                    {/*        <SwiperSlide key={index}>*/}
                    {/*            <div className="swiper-zoom-container">*/}
                    {/*                <img*/}
                    {/*                    src={*/}
                    {/*                        getBaseImagePath() +*/}
                    {/*                        convertImageToSize(image, ImageSize.ORIIGINAL).url*/}
                    {/*                    }*/}
                    {/*                    alt={`${altString} - ${index + 1}`}*/}
                    {/*                />*/}
                    {/*            </div>*/}
                    {/*        </SwiperSlide>*/}
                    {/*    ))}*/}
                    {/*</Swiper>*/}


                    <Link to={`/catalog/item/${product.catalog_code}/${product.id}/${product.human_url}`}
                          className="prod-card__img-link">
                        <div className="carousel carousel-prod-card slide">
                            <div className="carousel-inner">
                                <div className="carousel-item  active">
                                    <picture>
                                        <img src={'https://www.pride.ru' + (product.list_image || '/images/no-photo.jpg' )}
                                             className="w-auto d-block h-auto m-auto" alt={product.name}/>
                                    </picture>
                                </div>
                            </div>
                        </div>
                    </Link>
                </div>
            </div>

            <div className="d-flex flex-column align-items-start prod-card__body">
                <div className="d-flex align-items-center prod-card__star-box">
                    <div className="d-flex prod-card__star-row">
                        <div className="prod-card__star orange"></div>
                        <div className="prod-card__star orange"></div>
                        <div className="prod-card__star orange"></div>
                        <div className="prod-card__star orange"></div>
                        <div className="prod-card__star"></div>
                    </div>
                    <p className="t-gray prod-card__star-text">18</p>
                </div>
                <div className="prod-card__text prod-card__title t-elips-3">
                    <Link to={`/catalog/item/${product.catalog_code}/${product.id}/${product.human_url}`}
                          className="prod-card__img-link">
                        {product.name}
                    </Link>
                </div>
                {product.client_price && <p className={'prod-card__text fw-bold ' + (product.has_client_stock ? 'text-success' : 'text-danger')}>{product.has_client_stock ? 'В наличии ' + product.client_smart_stock : 'Нет в наличии'}</p>}
                {!product.client_price && <p className={'prod-card__text fw-bold ' + (product.has_stock ? 'text-success' : 'text-danger')}>{product.has_stock ? 'В наличии ' + product.smart_stock : 'Нет в наличии'}</p>}
                <p className="prod-card__text"><span className="t-gray">Артикул:</span> {product.articul}</p>

                {product.client_price && product.client_base_price && <>
                    <div className="d-flex align-items-end prod-card__price">
                        {product.client_base_price.amount > product.client_price.amount &&
                            <p className="prod-card__text fw-medium t-gray text-decoration-line-through"><Money
                                value={product.client_base_price}/></p>}
                        <p className="prod-card__text fw-bold big t-orange"><Money value={product.client_price}/></p>
                    </div>
                </>}
                {!product.client_price && <>
                    <div className="d-flex align-items-end prod-card__price">
                        {product.base_price.amount > product.current_price.amount &&
                            <p className="prod-card__text fw-medium t-gray text-decoration-line-through"><Money
                                value={product.base_price}/></p>}
                        <p className="prod-card__text fw-bold big t-orange"><Money value={product.current_price}/></p>
                    </div>
                </>}

                {product.has_client_stock ?
                    <button type="button" className={'btn prod-card__btn ' + (inBasket() ? 'btn-dark disabled' : 'btn-primary')} onClick={addToBasket}>{inBasket() ? 'В корзине' : 'Добавить'}</button> : ''}
            </div>
        </div>)
}